import { useState, useEffect } from 'react'
import { FaDesktop, FaTrash, FaCopy, FaClock } from 'react-icons/fa'
import './ClipboardTool.css'

function ClipboardTool() {
  const [clipboardHistory, setClipboardHistory] = useState([])
  const [isSupported, setIsSupported] = useState(true)

  useEffect(() => {
    // 检查剪贴板 API 是否可用
    if (!navigator.clipboard || !navigator.clipboard.readText) {
      setIsSupported(false)
      return
    }

    // 尝试读取剪贴板
    readClipboard()

    // 定期读取剪贴板（每 2 秒）
    const interval = setInterval(readClipboard, 2000)

    return () => clearInterval(interval)
  }, [])

  const readClipboard = async () => {
    try {
      const text = await navigator.clipboard.readText()
      if (text) {
        addToHistory(text)
      }
    } catch (error) {
      // 权限被拒绝或剪贴板为空
      console.log('无法读取剪贴板:', error)
    }
  }

  const addToHistory = (text) => {
    setClipboardHistory(prev => {
      // 如果已存在，移动到顶部
      const filtered = prev.filter(item => item.text !== text)
      return [
        {
          id: Date.now(),
          text,
          timestamp: new Date().toLocaleTimeString()
        },
        ...filtered
      ].slice(0, 50) // 最多保留 50 条
    })
  }

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text)
    } catch (error) {
      console.error('复制失败:', error)
    }
  }

  const deleteItem = (id) => {
    setClipboardHistory(prev => prev.filter(item => item.id !== id))
  }

  const clearHistory = () => {
    if (window.confirm('确定要清空所有剪贴板历史吗？')) {
      setClipboardHistory([])
    }
  }

  if (!isSupported) {
    return (
      <div className="clipboard-not-supported">
        <FaDesktop className="not-supported-icon" />
        <h3>剪贴板 API 不支持</h3>
        <p>您的浏览器不支持剪贴板访问功能。请使用现代浏览器（Chrome、Edge、Firefox）并确保在安全的上下文（HTTPS 或 localhost）中运行。</p>
        <div className="platform-badge-large desktop">
          <FaDesktop /> 仅电脑端可用
        </div>
      </div>
    )
  }

  return (
    <div className="clipboard-tool">
      <div className="platform-notice">
        <span className="platform-support desktop-only">
          <FaDesktop /> 此功能仅电脑端可用
        </span>
      </div>

      <div className="clipboard-header">
        <h3>剪贴板历史</h3>
        <div className="clipboard-stats">
          <span>{clipboardHistory.length} 条记录</span>
          {clipboardHistory.length > 0 && (
            <button className="clear-btn" onClick={clearHistory}>
              <FaTrash /> 清空
            </button>
          )}
        </div>
      </div>

      <div className="clipboard-list">
        {clipboardHistory.length === 0 ? (
          <div className="empty-state">
            <p>剪贴板历史为空</p>
            <p className="hint">复制任何文本，它将自动出现在这里</p>
          </div>
        ) : (
          clipboardHistory.map((item) => (
            <div key={item.id} className="clipboard-item">
              <div className="item-content">
                <p className="item-text" title={item.text}>
                  {item.text.length > 100 
                    ? item.text.substring(0, 100) + '...' 
                    : item.text}
                </p>
                <span className="item-time">
                  <FaClock /> {item.timestamp}
                </span>
              </div>
              <div className="item-actions">
                <button
                  className="action-btn copy"
                  onClick={() => copyToClipboard(item.text)}
                  title="复制"
                >
                  <FaCopy />
                </button>
                <button
                  className="action-btn delete"
                  onClick={() => deleteItem(item.id)}
                  title="删除"
                >
                  <FaTrash />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default ClipboardTool